/**
 * SaveTranscript — the editable transcript (#32), its low-confidence
 * flag, and the retry button for a recording that couldn't be transcribed yet.
 */

import { Chip } from "./Chip";

export interface SaveTranscriptProps {
  transcript?: string;
  transcriptDraft: string;
  handleTranscriptInput: (value: string) => void;
  lowConfidence?: boolean;
  canRetryTranscription: boolean;
  onRetryTranscription?: () => void;
}

export function SaveTranscript({
  transcript,
  transcriptDraft,
  handleTranscriptInput,
  lowConfidence,
  canRetryTranscription,
  onRetryTranscription,
}: SaveTranscriptProps) {
  return (
    <>
      {/* #32: the transcript is rendered here as an EDITABLE field (rule #2 —
          the human confirms/corrects the heard text before it commits), NOT on
          a standalone interstitial. Rendered only when a transcript exists
          (undefined = photo-only / video-pending → no field); "" still renders
          the blank field so an empty-STT voice capture can be typed in. */}
      {transcript !== undefined && (
        <section data-testid="save-transcript" data-skin-slot="SK-SAVE">
          {lowConfidence && (
            <p class="transcript-lowconf-flag" data-testid="save-transcript-lowconf-flag" role="status">
              Low confidence — please check this transcript.
            </p>
          )}
          <label>
            Transcript
            <textarea
              data-testid="save-transcript-textarea"
              value={transcriptDraft}
              onInput={(e) => handleTranscriptInput((e.target as HTMLTextAreaElement).value)}
              rows={4}
            />
          </label>
          {canRetryTranscription && onRetryTranscription && transcriptDraft.trim() === "" && (
            <div class="save-transcript-recovery" data-testid="save-transcript-recovery">
              <p class="save-transcript-recovery-copy">
                This recording is saved on this device. Reconnect, then retry transcription.
              </p>
              <Chip
                class="save-transcript-retry"
                data-testid="save-transcript-retry"
                onClick={onRetryTranscription}
              >
                Retry transcription
              </Chip>
            </div>
          )}
        </section>
      )}
    </>
  );
}
